module.exports = __webpack_public_path__ + "img/icon-more.bdd47b31.svg";